import { Component, ViewChild, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { PreviousAddress } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { VendorResponseTypes } from 'src/app/packages-module/models/searchPackage';
import { TriggerRecordTogglePayload, FilterableRecordSubTypes } from 'src/app/models/screeningInvite';
import { take, tap } from 'rxjs/operators';
import { ScreeningService } from '../../services/screening.service';

@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.less']
})
export class AddressListComponent  implements OnInit, OnDestroy {
  @ViewChild('appData', {}) ngForm: NgForm;
  public aliasSearch : string;
  @Input() screeningId : number;
  @Input() clientId : number;
  @Input() toggleAll : Observable<boolean>;

  $toggleAllSub : Subscription;
  lastKey : any = {
    key : 'excludeFromReport',
    ascending : false
  };
   
  public get personase() : number {
    return this.screening.screenings[0].additionalData.find(as=>{return as.searchTypeEnum == VendorResponseTypes.Person;}).searchEntryId;
  }
  
  public get creditase() : number {
    return this.screening.screenings[0].additionalData.find(as=>{return as.searchTypeEnum == VendorResponseTypes.Credit;}).searchEntryId;
  }
  
  public get filteredAddresses() : PreviousAddress[] {
    if(this.aliasSearch) {
      return this.appData.sortByKey(this.appData.addressRecords.filter((str: PreviousAddress) => { 
        return str.street.toLowerCase().indexOf(this.aliasSearch.toLowerCase()) !== -1; 
      }),this.lastKey.key,this.lastKey.ascending);
    }
    let sorted = this.appData.sortByKey(this.appData.addressRecords,this.lastKey.key,this.lastKey.ascending);
    // console.debug(sorted);
    return sorted;
  }
  
  constructor(public appData: ApplicantDataService, public toast : ToastrService, public screening : ScreeningService){}
  ngOnDestroy(): void {
    this.$toggleAllSub.unsubscribe();
  }
  ngOnInit(): void {
    this.appData.GetAddressRecordsForApplicant(this.screeningId);
    this.$toggleAllSub = this.toggleAll.subscribe((val :boolean)=> {
      console.debug('Toggle All got called for the following addresses.', this.filteredAddresses);
      // are all the aliases selected of a single type?
      let ssn_addresses = this.filteredAddresses.filter(al=>al.tableName.indexOf('Person') > -1);
      let credit_addresses = this.filteredAddresses.filter(al=>al.tableName.indexOf('Credit') > -1);

      let plds : TriggerRecordTogglePayload[] = [];
    
      if(ssn_addresses.length > 0){
        let pld = this.buildTogglePayload(val,ssn_addresses,VendorResponseTypes.Person);
        plds.push(pld);
      }
      if(credit_addresses.length > 0){
        let pld = this.buildTogglePayload(val,credit_addresses,VendorResponseTypes.Credit);
        plds.push(pld);
      }
     
      this.fireUpdate(plds);
  });
  }


  buildTogglePayload(include : boolean, records: PreviousAddress[], type : VendorResponseTypes) : TriggerRecordTogglePayload{
    let pld = new TriggerRecordTogglePayload();
    pld.recordIds = records.map(fa=>fa.id);
    pld.recordsIncluded = include;
    pld.searchType = type;
    if(type == VendorResponseTypes.Person) pld.searchEntryId = this.personase;
    else pld.searchEntryId = this.creditase;
    pld.subType = FilterableRecordSubTypes.Address;
    pld.screeningId = this.screeningId;
    pld.clientId = this.clientId;

    return pld;
  }

  fireUpdate(rcrds : TriggerRecordTogglePayload[]){
    this.appData.ToggleRecord2(rcrds).pipe(take(1), tap(_=>{
      console.info(_);
     })).subscribe(()=>{
       this.toast.success(`Record Toggle Success`);
       rcrds.forEach(rc=>{
         rc.recordIds.forEach(r=>{
           this.appData._addressRecords.find(al=>{return al.id == r}).excludeFromReport = !rc.recordsIncluded;
         })
        });
     },
     ()=>{this.toast.error(`Record Toggle Failed`);});
  }
  
  toggleRecordStatus(include : boolean, record : PreviousAddress){
    let searchType;
    if(record.tableName == "Person_Address")
      searchType = VendorResponseTypes.Person;
    else
      searchType = VendorResponseTypes.Credit;

    let pld = this.buildTogglePayload(include,[record],searchType);
   
    this.fireUpdate([pld]);

  }


  sort(key : string){
    if(this.lastKey.key == key){
      this.lastKey.ascending = !this.lastKey.ascending;
    }else{
      this.lastKey.key = key;
      this.lastKey.ascending = false;
    }
  }

  searchAlias(){
    // console.debug('alias search was updated',this.aliasSearch);
  }
}
